import React from 'react';

import { getImageData } from '../../../utils/contentful';
import { GlImage } from '../../Image';

import { AssetProps } from '../shared';
import cx from 'classnames';

export function ImageAsset({ asset, rounded }: AssetProps) {
  return (
    <div className="relative w-full tablet:w-auto tablet:grow-[1.5]">
      <GlImage
        {...getImageData(asset)}
        data-blockid="assetWith5050Text-image"
        className={cx('max-w-full block mx-auto', {
          'rounded-3xl tablet:rounded-4xl': rounded
        })}
      />
    </div>
  );
}
